<template>
  <select v-model="selected" @change="changeFilter" v-if="filterItem.filter_item_list.length > 0">
    <option v-for="(option, optionIndex) in filterItem.filter_item_list"
            :key="'filter_item_' + optionIndex" :value="option.api_path" :data-adult="option.adult">
      {{option.title}}
    </option>
  </select>
</template>

<script>
import _ from 'lodash'
import { CHANGE_FILTER } from '@/common/resources/const'
import { parseUrl, stringify, parse } from 'query-string'
export default {
  name: 'FilterItem',
  props: {
    filterItem: {
      type: Object
    },
    baseApi: {
      type: String
    }
  },
  data () {
    return {
      selected: '',
      initialSelectedIndex: 0
    }
  },
  methods: {
    setSelected () {
      const title = this.filterItem.title
      this.initialSelectedIndex = _.findIndex(_.get(this.filterItem, 'filter_item_list', []), { 'title': title })
      this.selected = _.get(this.filterItem, ['filter_item_list', this.initialSelectedIndex, 'api_path'], '')
    },
    changeFilter () {
      const selectedIndex = _.findIndex(_.get(this.filterItem, 'filter_item_list', []), { 'api_path': this.selected })
      const selectedFilterItem = _.get(this.filterItem, ['filter_item_list', selectedIndex], {})
      // eslint-disable-next-line camelcase
      const { api_path = '', api_parameters = '' } = selectedFilterItem
      let api = this.baseApi.replace('{path}', api_path)
      const { url, query } = parseUrl(api)
      const newQuery = _.assign({}, query, parse(api_parameters))
      this.$events.$emit(CHANGE_FILTER, url + '?' + stringify(newQuery))
    }
  },
  created () {
    this.setSelected()
  }
}
</script>
